import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Checkout from './pages/Checkout';
import CheckoutResult from './pages/CheckoutResult';
import Dashboard from './pages/Dashboard';
import Onboarding from './pages/Onboarding';
import Servers from './pages/Servers';
import Growth from './pages/Growth';
import PublisherIndex from './pages/PublisherIndex';
import SchemaConfirm from './pages/SchemaConfirm';
import AlertsPage from './pages/AlertsPage';
import Notifications from './pages/Notifications';
import LicensePage from './pages/LicensePage';
import Referral from './pages/Referral';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminCoupons from './pages/admin/AdminCoupons';
import AdminCustomer from './pages/admin/AdminCustomer';
import AdminPublishers from './pages/admin/AdminPublishers';
import AdminSettings from './pages/admin/AdminSettings';
import AdminMonitoring from './pages/admin/AdminMonitoring';
import AdminAlerts from './pages/admin/AdminAlerts';
import AdminAgents from './pages/admin/AdminAgents';
import AdminGrowth from './pages/admin/AdminGrowth';
import LegalPage from './pages/LegalPage';
import PublishersLanding from './pages/PublishersLanding';
import PublisherRegister from './pages/publisher/PublisherRegister';
import PublisherLogin from './pages/publisher/PublisherLogin';
import PublisherPanel from './pages/publisher/PublisherPanel';
import NotFound from './pages/NotFound';
import CookieNotice from './components/CookieNotice';

const sub = (el) => <ProtectedRoute requireSubscription>{el}</ProtectedRoute>;

// Admin'in sunucusu yok — /dashboard ve /dashboard/alerts admin için operatör görünümü.
function RoleView({ admin, member }) {
  const { user } = useAuth();
  return user?.role === 'admin' ? admin : member;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route path="/gizlilik-politikasi" element={<LegalPage slug="gizlilik-politikasi" />} />
          <Route path="/kullanim-kosullari" element={<LegalPage slug="kullanim-kosullari" />} />
          <Route path="/kvkk" element={<LegalPage slug="kvkk" />} />

          {/* Yayıncı Öz-Servis Katmanı (Faz 5) — server sahibinden bağımsız, ayrı auth */}
          <Route path="/yayincilar" element={<PublishersLanding />} />
          <Route path="/yayinci/kayit" element={<PublisherRegister />} />
          <Route path="/yayinci/giris" element={<PublisherLogin />} />
          <Route path="/yayinci/panel" element={<PublisherPanel />} />

          <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
          <Route path="/checkout/success" element={<ProtectedRoute><CheckoutResult outcome="success" /></ProtectedRoute>} />
          <Route path="/checkout/failed" element={<ProtectedRoute><CheckoutResult outcome="failed" /></ProtectedRoute>} />

          <Route path="/onboarding" element={sub(<Onboarding />)} />
          <Route path="/onboarding/schema-confirm" element={sub(<SchemaConfirm />)} />
          <Route path="/dashboard" element={sub(<RoleView admin={<AdminMonitoring />} member={<Dashboard />} />)} />
          <Route path="/dashboard/alerts" element={sub(<RoleView admin={<AdminAlerts />} member={<AlertsPage />} />)} />
          <Route path="/dashboard/servers" element={sub(<Servers />)} />
          <Route path="/dashboard/growth" element={sub(<Growth />)} />
          <Route path="/dashboard/publishers" element={sub(<PublisherIndex />)} />
          <Route path="/dashboard/notifications" element={sub(<Notifications />)} />
          <Route path="/dashboard/license" element={sub(<LicensePage />)} />
          <Route path="/dashboard/referral" element={sub(<Referral />)} />

          <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/agents" element={<ProtectedRoute role="admin"><AdminAgents /></ProtectedRoute>} />
          <Route path="/admin/publishers" element={<ProtectedRoute role="admin"><AdminPublishers /></ProtectedRoute>} />
          <Route path="/admin/growth" element={<ProtectedRoute role="admin"><AdminGrowth /></ProtectedRoute>} />
          <Route path="/admin/coupons" element={<ProtectedRoute role="admin"><AdminCoupons /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute role="admin"><AdminSettings /></ProtectedRoute>} />
          <Route path="/admin/customers/:id" element={<ProtectedRoute role="admin"><AdminCustomer /></ProtectedRoute>} />

          <Route path="*" element={<NotFound />} />
        </Routes>
        <CookieNotice />
      </BrowserRouter>
    </AuthProvider>
  );
}
